import {
	FilterDefinition,
	FilterKey,
	FilterRow,
	FilterSelection,
	ReportView
} from './TrainingReports.types';

export const REPORT_TITLE = 'Training Report';
export const REPORT_SUBTITLE =
	'Track training completion, identify gaps, and monitor certification across properties';

export const VIEW_LABELS: Record<ReportView, string> = {
	[ReportView.Dashboard]: 'Dashboard',
	[ReportView.Report]: 'Report'
};

export const DEFAULT_REPORT_VIEW = ReportView.Dashboard;

export const SEARCH_PLACEHOLDER = 'Search people...';

export const FILTER_DEFINITIONS: FilterDefinition[] = [
	{
		key: FilterKey.Assignments,
		label: 'All assignments',
		chipLabel: 'Asgn',
		row: FilterRow.Primary,
		multiple: true,
		icon: 'assignmentsFilterIcon'
	},
	{
		key: FilterKey.Courses,
		label: 'All courses',
		chipLabel: 'Course',
		row: FilterRow.Primary,
		multiple: true,
		icon: 'indiCoursesOutline'
	},
	{
		key: FilterKey.Status,
		label: 'Status',
		chipLabel: 'Status',
		row: FilterRow.Primary,
		multiple: false,
		options: [
			{ value: 'notStarted', label: 'Not Started' },
			{ value: 'complete', label: 'Complete' },
			{ value: 'overdue', label: 'Overdue' }
		]
	},
	{
		key: FilterKey.CourseType,
		label: 'Course type',
		chipLabel: 'Course type',
		row: FilterRow.Primary,
		multiple: false,
		options: [
			{ value: 'required', label: 'Required' },
			{ value: 'optional', label: 'Optional' }
		]
	},
	{
		key: FilterKey.Property,
		label: 'Property',
		chipLabel: 'Property',
		row: FilterRow.More,
		multiple: false
	},
	{
		key: FilterKey.Group,
		label: 'Group',
		chipLabel: 'Group',
		row: FilterRow.More,
		multiple: false
	},
	{
		key: FilterKey.Role,
		label: 'Role',
		chipLabel: 'Role',
		row: FilterRow.More,
		multiple: false
	},
	{
		key: FilterKey.Recertification,
		label: 'Recertification',
		chipLabel: 'Recertification',
		row: FilterRow.More,
		multiple: false,
		dividerBefore: true,
		options: [
			{ value: 'next30', label: 'Next 30 days' },
			{ value: 'next60', label: 'Next 60 days' },
			{ value: 'next90', label: 'Next 90 days' },
			{ value: 'overdue', label: 'Overdue' }
		]
	}
];

export const FILTER_CHIP_LABELS = FILTER_DEFINITIONS.reduce(
	(labels, definition) => ({
		...labels,
		[definition.key]: definition.chipLabel
	}),
	{} as Record<FilterKey, string>
);

/**
 * The "All" row that heads every filter menu. Picking it clears that filter,
 * which is what returns the dashboard to its default state.
 */
export const ALL_OPTION_VALUE = 'all';

export const ALL_OPTION_LABELS: Partial<Record<FilterKey, string>> = {
	[FilterKey.CourseType]: 'All courses types'
};

export const DEFAULT_ALL_OPTION_LABEL = 'All';

export const EMPTY_FILTER_SELECTION: FilterSelection = Object.values(
	FilterKey
).reduce((acc, key) => ({ ...acc, [key]: [] }), {} as FilterSelection);
